// "Você quis dizer …@gmail.com?" for the usual slips in the e-mail domain (gmail.con, gmial.com, gmail.com.br…).
// Only a suggestion under the field: the person decides.
const DOMAINS = [
  "gmail.com",
  "hotmail.com",
  "outlook.com",
  "yahoo.com.br",
  "yahoo.com",
  "icloud.com",
  "live.com",
  "uol.com.br",
  "bol.com.br",
  "terra.com.br",
  "msn.com",
  "hotmail.com.br",
  "outlook.com.br",
];
const KNOWN = new Set(DOMAINS);
// Domains that look right but do not take addresses.
const FIXED = { "gmail.com.br": "gmail.com", "icloud.com.br": "icloud.com" };

function distance(a, b) {
  const row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let prev = row[0];
    row[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const tmp = row[j];
      row[j] =
        a[i - 1] === b[j - 1]
          ? prev
          : 1 + Math.min(prev, row[j], row[j - 1]);
      prev = tmp;
    }
  }
  return row[b.length];
}

export function suggestEmail(value) {
  const email = String(value || "").trim().toLowerCase();
  const at = email.lastIndexOf("@");
  if (at < 1 || at === email.length - 1) return null;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (KNOWN.has(domain)) return null;
  if (FIXED[domain]) return `${local}@${FIXED[domain]}`;
  let best = null;
  let bestDist = 3;
  for (const d of DOMAINS) {
    const dist = distance(domain, d);
    if (dist < bestDist) {
      best = d;
      bestDist = dist;
    }
  }
  // Short domains need a closer match (a real "gmx.com" is not "gmail.com").
  if (!best || (bestDist === 2 && domain.length < 8)) return null;
  return `${local}@${best}`;
}
